import { apiCall } from '../utils/api';

async function parseJsonResponse(response) {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || data.message || 'Something went wrong.');
  }

  return data;
}

export async function createPaymentOrder(payload) {
  const response = await apiCall('/api/payment/create-order', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return parseJsonResponse(response);
}

export async function fetchPaymentDetails(params = {}) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      query.set(key, String(value).trim());
    }
  });

  const response = await apiCall(`/api/payment/details${query.toString() ? `?${query.toString()}` : ''}`);
  return parseJsonResponse(response);
}

export async function fetchPaymentConfig() {
  const response = await apiCall('/api/payment/config');
  return parseJsonResponse(response);
}

export async function verifyPayment(payload) {
  const response = await apiCall('/api/payment/verify', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return parseJsonResponse(response);
}

export async function markPaymentFailed(payload) {
  const response = await apiCall('/api/payment/fail', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return parseJsonResponse(response);
}

export async function fetchPaymentHistory(params = {}) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      query.set(key, String(value).trim());
    }
  });

  const response = await apiCall(`/api/payment/history${query.toString() ? `?${query.toString()}` : ''}`);
  return parseJsonResponse(response);
}

export async function fetchAdminPaymentHistory(params = {}, apiBaseUrl = '') {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      query.set(key, String(value).trim());
    }
  });

  const adminToken = sessionStorage.getItem('adminToken');
  const headers = {
    'Content-Type': 'application/json'
  };

  if (adminToken) {
    headers.Authorization = `Bearer ${adminToken}`;
  }

  const baseUrl = String(apiBaseUrl || '').replace(/\/+$/, '');
  const requestUrl = `${baseUrl}/api/admin/payment/history${query.toString() ? `?${query.toString()}` : ''}`;

  const response = await fetch(requestUrl, {
    method: 'GET',
    headers
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || data.message || 'Something went wrong.');
  }

  return data;
}
